/* eslint-disable */

export const accuracyPreparedVolumeBuy = {
    GET_ACCURACY_PREPEARED_VOLUME_BUY_REQUEST: 'GET_ACCURACY_PREPEARED_VOLUME_BUY_REQUEST',
    GET_ACCURACY_PREPEARED_VOLUME_BUY_SUCCESS: 'GET_ACCURACY_PREPEARED_VOLUME_BUY_SUCCESS',
    GET_ACCURACY_PREPEARED_VOLUME_BUY_FAILURE: 'GET_ACCURACY_PREPEARED_VOLUME_BUY_FAILURE',
};
